import React from 'react';
import {connect} from "react-redux";
import { withRouter } from "react-router-dom";
import LoginComponent from "./login-component";
import {inputChange, loginRequest} from "./login-action-creators";

const LoginContainer = props => <LoginComponent {...props} />;

const mapStateToProps = state => ({
  username: state.login.username,
  password: state.login.password,
  loading: state.login.loading,
  error: state.login.error
});


const mapDispatchToProps = (dispatch, ownProps) => ({
  inputChange: ({value, field}) => dispatch(inputChange({value, field })),
  login: () => dispatch(loginRequest(ownProps.history))
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginContainer));


// WEBPACK FOOTER //
// ./src/modules/login/login-container.js